import React from 'react';
import { Link } from 'react-router-dom';
import './../../styles/admin/Sidebar.css';

const Sidebar = () => {
    return (
        <div className="sidebar">
            <ul>
                <li>
                    <Link to="/admin">Inicio</Link>
                </li>
                <li>
                    <Link to="/admin/productos">Productos</Link>
                </li>
                <li>
                    <Link to="/admin/ventas">Ventas</Link>
                </li>
                <li>
                    <Link to="/admin/clientes">Clientes</Link>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;